import React from 'react';
import { isEmpty, getPointName, isEnergyDevice, getLocale } from '../../Common/Common';

//Returns an array of month selection
export function getMonthSelect() {
	let months = [];

	for (let i = 0; i < 12; i++) {
		months.push(<option value={i}>{convertMonthMon(i)}</option>)
	}

	return months;
}

// Translate month names using stringtable
function convertMonthMon(mth) {
	let month = new Array();
	month[0] = window.app.receiver.getString("month1");
	month[1] = window.app.receiver.getString("month2");
	month[2] = window.app.receiver.getString("month3");
	month[3] = window.app.receiver.getString("month4");
	month[4] = window.app.receiver.getString("month5");
	month[5] = window.app.receiver.getString("month6");
	month[6] = window.app.receiver.getString("month7");
	month[7] = window.app.receiver.getString("month8");
	month[8] = window.app.receiver.getString("month9");
	month[9] = window.app.receiver.getString("month10");
	month[10] = window.app.receiver.getString("month11");
	month[11] = window.app.receiver.getString("month12");

	return month[mth];
}

// Returns an array of past years selection, num_years is number of years
export function getYearSelect(num_years) {
	let years = [];
	let date = new Date();

	for (let i = 0; i < num_years; i++) {
		years.push(<option value={date.getFullYear()}>{date.getFullYear()}</option>)
		date.setYear(date.getFullYear() - 1);
	}

	return years;
}

// Returns an array of month selection for Energy/Water
export function getChartMonthSelect(start_date, year) {
	let months = [];
	let from = new Date();
	from.setYear(year);

	let locale = getLocale(window.app.receiver.lang);
	let df_options = { month: 'short', day: 'numeric' };

	for (let i = 0; i < 12; i++) {
		from.setDate(1);
		let to = new Date(from);

		from.setMonth(i);
		from.setDate(start_date);
		if (from.getMonth() > i) {
			from.setDate(1);
		}

		to.setMonth(i + 1);
		to.setDate(start_date - 1);
		if (to.getMonth() > (i + 1)) {
			to.setDate(0);
		}

		let from_string = from.toLocaleString(locale, df_options);
		let to_string = to.toLocaleString(locale, df_options);

		months.push(<option value={i}>{from_string + ' - ' + to_string}</option>)
	}

	return months;
}

// Returns an array of past years selection, num_years is number of years for Energy/Water
export function getYearSelectWithStartDate(num_years, start_month, start_date) {
	let years = [];
	let date = new Date();

	let locale = getLocale(window.app.receiver.lang);
	let df_options = { day: '2-digit', month: 'short', year: 'numeric' };

	let from = new Date();

	for (let i = 0; i < num_years; i++) {
		from.setMonth(start_month)
		from.setDate(start_date);
		if (from.getMonth() > start_month) from.setDate(1);

		let to = new Date(from);
		to.setYear(from.getFullYear() + 1);

		let temp_month = to.getMonth();
		to.setDate(start_date);
		if (to.getMonth() > temp_month) to.setDate(0);

		// To Date = From Date + 1 year - 1 day
		to.setDate(to.getDate() - 1);

		let from_string = from.toLocaleString(locale, df_options);
		let to_string = to.toLocaleString(locale, df_options);
		years.push(<option value={from.getFullYear()}>{from_string + ' - ' + to_string}</option>);
		from.setYear(date.getFullYear() - 1);
	}

	return years;
}

// returns an array of management point ids for query
export function getEWManagementPoints(categories, report_type) {
	let points = [];

	if (report_type == 'energy_management') {
		if (!categories.is_show_energy_categories) {
			for (let point_id in window.app.state.point_list) {
				let point_info = window.app.state.point_list[point_id];
				if (isEnergyDevice(point_info)) {
					points.push(point_id)
				}
			}
		} else {
			for (let category_id in categories.energy) {
				// Check if each category is enabled. If not enabled, do not get the data from the points
				if (categories.energy[category_id].is_enabled) {
					points = points.concat(categories.energy[category_id].points);
				}
			}
			if (categories.is_energy_generator_enabled) {
				points = points.concat(categories.energy_generator.points)
			}
		}
	} else if (report_type == 'water_management') {
		if (categories.is_water_consumption_enabled) {
			points = points.concat(categories.water_consumption.points)
		}
		if (categories.is_recycled_water_enabled) {
			points = points.concat(categories.recycled_water.points)
		}
	}

	return points;
}

// Returns Chart Data for display
export function getEnergyWaterChartData(report_type, meter_info, period, start_date, categories) {
	if (isEmpty(meter_info.data)) {
		return [];
	}
	let chart_data = [];
	/*
	 * Chart_data format
	 * [
		   ['x', '2013-01-01 00:00:00', '2013-01-02 01:00:00', '2013-01-03 02:00:00', '2013-01-04 03:00:00', '2013-01-05 04:00:00', '2013-01-06 05:00:00'],
		   ['Lights', 30, 200, 100, 400, 150, 250],
		   ['Equipment', 130, 100, 140, 200, 150, 50]
	   ],
	 */

	// First row is the series of timestamps with x as identifier (i.e. x-axis)
	let time_series = getTimeSeries(period, start_date);
	chart_data.push(time_series);

	if (period == 'day') {
		// Day data format returned by controller is an array of 24 values.
		chart_data = setDayChartData(report_type, chart_data, categories, meter_info);
	} else if (period == 'month' || period == 'year') {
		// month/year data format returned by controller is a hash with date as key. 
		// If meter has no data in that time period, nothing will be sent
		chart_data = setTimeseriesChartData(report_type, chart_data, categories, meter_info, time_series, period);
	}

	// set the total sum of values for each time period
	chart_data = setTotalData(chart_data);
	return chart_data;
}

function getTimeSeries(period, start_date) {
	// Format timeseries into an array of timestamp strings with 'x' as the first element
	// Eg. ['x', '2013-01-01 00:00:00', '2013-01-02 01:00:00', '2013-01-03 02:00:00', '2013-01-04 03:00:00', '2013-01-05 04:00:00', '2013-01-06 05:00:00']
	let time_series = [];
	time_series.push('x');
	if (period == 'day') {
		// Check for report_settings start_date/month
		let today = new Date();
		for (let i = 0; i < 24; i++) {
			let year = start_date.getFullYear();
			let month = format2Digits(start_date.getMonth() + 1);
			let date = format2Digits(start_date.getDate());
			let hour = format2Digits(i);

			// Graph ends at current hour for past dates
			if (year >= today.getFullYear() && month >= today.getMonth() && date >= today.getDate()
				&& (date == today.getDate() && hour > today.getHours())) {
				break;
			}
			time_series.push(year + '-' + month + '-' + date + ' ' + hour + ':' + '00' + ':' + '00');
		}
	} else if (period == 'month') {
		let end_date = getMonthEndDate(start_date)

		while (start_date <= end_date) {
			let year = start_date.getFullYear();
			let month = format2Digits(start_date.getMonth() + 1);
			let date = format2Digits(start_date.getDate());

			time_series.push(year + '-' + month + '-' + date + ' ' + '00' + ':' + '00' + ':' + '00');
			start_date.setDate(start_date.getDate() + 1);
		}
	} else if (period == 'year') {
		// For display, if start date is bigger than 15, month displayed will be the next month
		// eg. 31 Jan - 28 Feb will be displayed as Feb data
		if (start_date.getDate() > 15) {
			// Check for report_settings start_date/month
			start_date.setDate(1); // For display, set date to 1 in order to get 12 months
			start_date.setMonth(start_date.getMonth() + 1);
		} else {
			// Check for report_settings start_date/month
			start_date.setDate(1); // For display, set date to 1 in order to get 12 months
		}

		let end_date = new Date(start_date);
		end_date.setYear(start_date.getFullYear() + 1);
		let today = new Date();
		if (end_date > today) end_date = today;

		while (start_date <= end_date) {
			let year = start_date.getFullYear();
			let month = format2Digits(start_date.getMonth() + 1);

			time_series.push(year + '-' + month + '-' + '01' + ' ' + '00' + ':' + '00' + ':' + '00');
			start_date.setMonth(start_date.getMonth() + 1);
		}
	}
	return time_series;
}

function setDayChartData(report_type, chart_data, categories, meter_info) {
	if (report_type == 'energy_management') {
		if (!categories.is_show_energy_categories) {
			chart_data = generateDayDataWithoutCategories(chart_data, meter_info);
		} else {
			for (let category_id in categories.energy) {
				if (categories.energy[category_id].is_enabled) {
					let points = categories.energy[category_id].points;
					let key_name = categories.energy[category_id].name;
					chart_data = generateDayDataWithCategories(chart_data, meter_info, points, key_name);
				}
			}

			if (categories.is_energy_generator_enabled) {
				let points = categories.energy_generator.points;
				let key_name = 'energy_generator';
				chart_data = generateDayDataWithCategories(chart_data, meter_info, points, key_name);
			}
		}
	} else if (report_type == 'water_management') {
		if (categories.is_water_consumption_enabled) {
			let points = categories.water_consumption.points;
			let key_name = 'water_consumption';
			chart_data = generateDayDataWithCategories(chart_data, meter_info, points, key_name);
		}

		if (categories.is_recycled_water_enabled) {
			let points = categories.recycled_water.points;
			let key_name = 'recycled_water';
			chart_data = generateDayDataWithCategories(chart_data, meter_info, points, key_name);
		}
	}

	function generateDayDataWithoutCategories(chart_data, meter_info) {
		for (let point_id in meter_info.data) {
			let point_name = getPointName(point_id);
			let row_data = [...meter_info.data[point_id]];
			// Add point name at the beginning of each row of data;
			row_data.unshift(point_name);
			chart_data.push(row_data);
		}

		return chart_data;
	}

	function generateDayDataWithCategories(chart_data, meter_info, points, key_name) {
		let row_data = [];
		for (let point_id of points) {
			if (meter_info.data[point_id] != null) {
				if (row_data.length == 0) {
					// If no data yet, copy meter_info.data[point_id]
					row_data = [...meter_info.data[point_id]];
				} else {
					row_data = row_data.map(function (num, idx) {
						/*
						 * Combine 2 arrays
						 * Eg. 
						 * var array1 = [1,2,3,4];
						 * var array2 = [5,6,7,8];
						 *       return [6,8,10,12]
						 */
						return num + meter_info.data[point_id][idx];
					});
				}
			}
		}

		// Convert all data to negative value. i.e. energy generator is negative energy consumption
		if (key_name == 'energy_generator') row_data = row_data.map(v => -(v));

		if (key_name == 'energy_generator' || key_name == 'water_consumption' || key_name == 'recycled_water') {
			key_name = window.app.receiver.getString(key_name);
		}

		if (row_data.length > 0) {
			// Add point name at the beginning of each row of data;
			row_data.unshift(key_name);
			// If there's data, then add into chart data
			chart_data.push(row_data);
		}

		return chart_data;
	}

	return chart_data;
}

function setTimeseriesChartData(report_type, chart_data, categories, meter_info, time_series, period) {
	if (report_type == 'energy_management') {
		if (!categories.is_show_energy_categories) {
			chart_data = generateTimeSeriesDataWithoutCategories(chart_data, meter_info, period);
		} else {
			for (let category_id in categories.energy) {
				if (categories.energy[category_id].is_enabled) {
					let key_name = categories.energy[category_id].name;
					let points = categories.energy[category_id].points;
					chart_data = generateTimeSeriesDataWithCategories(chart_data, key_name, points, meter_info, period);
				}
			}
			if (categories.is_energy_generator_enabled) {
				let key_name = 'energy_generator';
				let points = categories.energy_generator.points;
				chart_data = generateTimeSeriesDataWithCategories(chart_data, key_name, points, meter_info, period);
			}
		}
	} else if (report_type == 'water_management') {
		if (categories.is_water_consumption_enabled) {
			let key_name = 'water_consumption';
			let points = categories.water_consumption.points;
			chart_data = generateTimeSeriesDataWithCategories(chart_data, key_name, points, meter_info, period);
		}

		if (categories.is_recycled_water_enabled) {
			let key_name = 'recycled_water';
			let points = categories.recycled_water.points;
			chart_data = generateTimeSeriesDataWithCategories(chart_data, key_name, points, meter_info, period);
		}
	}

	function generateTimeSeriesDataWithoutCategories(chart_data, meter_info, period) {
		for (let point_id in meter_info.data) {
			let point_name = getPointName(point_id);
			let row_data = [];

			for (let timestamp of time_series) {
				if (timestamp != 'x') {
					// First find the key from using timestamp. eg. key = 20201201; 
					let year = timestamp.substring(0, 4);
					timestamp = timestamp.substring(timestamp.indexOf('-') + 1, timestamp.length);
					let month = timestamp.substring(0, timestamp.indexOf('-'));
					if (month.length < 2) month = '0' + month;
					timestamp = timestamp.substring(timestamp.indexOf('-') + 1, timestamp.length);
					let date = timestamp.substring(0, timestamp.indexOf(' '));
					if (date.length < 2) date = '0' + date;

					// key is used to identify data from controller
					let key = year + month + date;
					if (period == 'year') key = year + month;

					if (meter_info.data[point_id][key] != null) row_data.push(meter_info.data[point_id][key]);
					// Controller does not send data if doesnt exist, so need to push 0
					else row_data.push(0);
				}
			}

			// Add point name at the beginning of each row of data;
			row_data.unshift(point_name);

			chart_data.push(row_data);
		}

		return chart_data;
	}

	function generateTimeSeriesDataWithCategories(chart_data, key_name, points, meter_info, period) {
		let row_data = [];
		for (let point_id of points) {
			if (meter_info.data[point_id] != null) {
				let index = 0;
				for (let timestamp of time_series) {
					if (timestamp != 'x') {
						// First find the key from using timestamp. eg. key = 20201201; 
						let year = timestamp.substring(0, 4);
						timestamp = timestamp.substring(timestamp.indexOf('-') + 1, timestamp.length);
						let month = timestamp.substring(0, timestamp.indexOf('-'));
						if (month.length < 2) month = '0' + month;
						timestamp = timestamp.substring(timestamp.indexOf('-') + 1, timestamp.length);
						let date = timestamp.substring(0, timestamp.indexOf(' '));
						if (date.length < 2) date = '0' + date;

						// key is used to identify data from controller
						let key = year + month + date;
						if (period == 'year') key = year + month;

						if (meter_info.data[point_id][key] != null) {
							if (row_data[index] == null) row_data[index] = meter_info.data[point_id][key];
							else row_data[index] += meter_info.data[point_id][key];
						} else {
							if (row_data[index] == null) row_data[index] = 0;
						}
						index++;
					}
				}
			}
		}

		// Convert all data to negative value. i.e. energy generator is negative energy consumption
		if (key_name == 'energy_generator') row_data = row_data.map(v => -(v));

		if (key_name == 'energy_generator' || key_name == 'water_consumption' || key_name == 'recycled_water') {
			key_name = window.app.receiver.getString(key_name);
		}

		if (row_data.length > 0) {
			// Add point name at the beginning of each row of data;
			row_data.unshift(key_name);
			// If there's data, then add into chart data
			chart_data.push(row_data);
		}

		return chart_data;
	}

	return chart_data;
}

function setTotalData(chart_data) {
	if (chart_data.length < 2) {
		return chart_data;
	}
	// Assumption: All data is filled and no missing data
	// If missing data, chart_data should at least have value 0 in that column
	let total = [];
	total.push(window.app.receiver.getString('total_consumption'));

	for (let row of chart_data) {
		// First row is always time series.
		// eg. ['x', '2013-01-01 00:00:00', '2013-01-02 01:00:00', '2013-01-03 02:00:00', '2013-01-04 03:00:00', '2013-01-05 04:00:00', '2013-01-06 05:00:00'],
		if (row[0] == 'x') {
			continue;
		}

		let row_length = row.length;

		// At first, get the total for each column
		for (let i = 1; i < row_length; i++) {
			if (total[i] == null || total[i] == undefined) {
				total.push(row[i]);
			} else {
				total[i] = total[i] + row[i];
			}
		}
	}

	let total_length = total.length;
	for (let index = 2; index < total_length; index++) {
		// Accumulated total, sum up the data with the previous column data
		total[index] = total[index] + total[index - 1];
	}

	chart_data.push(total);
	return chart_data;
}

function format2Digits(digit) {
	if (digit < 10) digit = '0' + digit;
	return digit;
}

export function getTrendChartData(trend_data, search_date, duration, interval) {
	if (isEmpty(trend_data.data)) {
		return [];
	}
	let chart_data = [];
	/*
	 * Chart_data format
	 * [
		   ['x', '2013-01-01 00:00:00', '2013-01-02 01:00:00', '2013-01-03 02:00:00', '2013-01-04 03:00:00', '2013-01-05 04:00:00', '2013-01-06 05:00:00'],
		   ['sp', 'dtatcp1:1-00003', 21, 22, 20, 16, 16, 18],
		   ['temp', 'dtatcp1:1-00003', 23, 22, 24, 24, 24, 22]
		   ['non', 'dummy:1-00006', 80, 99, 100, 76, 54, 23]
	   ],
	 */

	// First row is the series of timestamps with x as identifier (i.e. x-axis)
	let time_series = getTrendTimeSeries(search_date, duration, interval);
	chart_data.push(time_series);
	chart_data = setTimeseriesTrendChartData(chart_data, trend_data, time_series);

	return chart_data;
}

export function getTrendTimeSeries(search_date, duration, interval) {
	// Format timeseries into an array of timestamp strings with 'x' as the first element
	// Eg. ['x', '2013-01-01 00:00:00', '2013-01-02 01:00:00', '2013-01-03 02:00:00', '2013-01-04 03:00:00', '2013-01-05 04:00:00', '2013-01-06 05:00:00']
	let time_series = [];
	time_series.push('x');

	let start_date = new Date(search_date);
	let end_date = new Date(search_date);
	end_date.setHours(start_date.getHours() + parseInt(duration));

	let now = new Date();
	if (end_date > now) end_date = now;

	while (start_date < end_date) {
		let year = start_date.getFullYear();
		let month = format2Digits(start_date.getMonth() + 1);
		let date = format2Digits(start_date.getDate());
		let hour = format2Digits(start_date.getHours());
		let min = format2Digits(start_date.getMinutes());
		//let sec = format2Digits(start_date.getSeconds());

		time_series.push(year + '-' + month + '-' + date + ' ' + hour + ':' + min + ':' + '00');
		start_date.setMinutes(start_date.getMinutes() + parseInt(interval))
	}

	return time_series;
}

function setTimeseriesTrendChartData(chart_data, trend_data, time_series) {
	for (let point_id in trend_data.data) {
		let dataset = trend_data.data[point_id];
		let point_info = window.app.state.point_list[point_id];

		let point_name = point_id;
		if (!isEmpty(point_info)) point_name = point_info.name;

		for (let type in dataset) {
			let row_data = [];
			row_data.push(type);
			row_data.push(point_id);

			for (let timestamp of time_series) {
				if (timestamp != 'x') {
					// First find the key from using timestamp. eg. key = 202012150945; 
					let year = timestamp.substring(0, 4);
					timestamp = timestamp.substring(timestamp.indexOf('-') + 1, timestamp.length);
					let month = timestamp.substring(0, timestamp.indexOf('-'));
					if (month.length < 2) month = '0' + month;
					timestamp = timestamp.substring(timestamp.indexOf('-') + 1, timestamp.length);
					let date = timestamp.substring(0, timestamp.indexOf(' '));
					if (date.length < 2) date = '0' + date;
					timestamp = timestamp.substring(timestamp.indexOf(' ') + 1, timestamp.length);
					let hour = timestamp.substring(0, timestamp.indexOf(':'));
					if (hour.length < 2) hour = '0' + hour;
					timestamp = timestamp.substring(timestamp.indexOf(':') + 1, timestamp.length);
					let min = timestamp.substring(0, timestamp.indexOf(':'));
					if (min.length < 2) min = '0' + min;

					// key is used to identify data from controller
					let key = year + month + date + hour + min;
					let val = null;

					for (let data of dataset[type]) {
						if (data[0] == key) {
							val = data[1];
							break;
						}
					}

					row_data.push(val);
				}
			}
			chart_data.push(row_data);
		}
	}

	return chart_data;
}

export function getTrendChartCategory(point_id) {
	// Returns the category of the management point
	// If management point is not in the list of selectable points, return ''
	let point_info = window.app.state.point_list[point_id];
	if (isEmpty(point_info)) {
		return '';
	}

	if (point_info.type == 'Ac') {
		// Ac 
		return 'temp'
	} else if (point_info.unit == 'DEG' && point_info.usage == 'temp') {
		// Temperature 
		return 'temp'
	} else if (point_info.unit == '%' && point_info.usage == 'humi') {
		// Humidity
		return 'humi';
	} else if (point_info.unit == '%' && point_info.usage == 'dehumi') {
		// Humidity
		return 'humi';
	} else if (point_info.unit == 'ppm' && point_info.usage == 'co2') {
		// CO2
		return 'co2';
	} else if (point_info.unit == 'µg/m3' && point_info.usage == 'pm25') {
		return 'PM2.5';
	} else if (point_info.unit != undefined && point_info.unit != null && point_info.unit != ''
		&& point_info.unit != 'kWh') {
		return point_info.unit;
	} else {
		return 'others';
	}
}

export function getMonthEndDate(start_date) {
	let end_date = new Date(start_date);
	end_date.setMonth(start_date.getMonth() + 1);
	end_date.setDate(start_date.getDate() - 1);
	if (end_date.getMonth() > (start_date.getMonth() + 1)) {
		end_date.setDate(0);
	}

	let today = new Date();
	if (end_date > today) {
		if (start_date.getMonth() == today.getMonth() && start_date.getFullYear() == today.getFullYear()) {
			//End date data is not included
			end_date = today;
			end_date.setDate(today.getDate() + 1);
		}
	}

	return end_date;
}

export function getDefaultMonth(report_settings, selected_year, selected_month) {
	if (!isEmpty(report_settings)) {
		if (report_settings.start_day != null) {
			let temp_date = new Date();
			temp_date.setYear(selected_year);
			temp_date.setMonth(selected_month);
			temp_date.setDate(report_settings.start_day);
			let today = new Date();

			if (temp_date > today) {
				temp_date.setMonth(temp_date.getMonth() - 1);
				selected_month = temp_date.getMonth()
			}
		}
	}

	return selected_month;
}